import { render, staticRenderFns } from "./InvoiceDetectedInfo.vue?vue&type=template&id=3442f043&scoped=true&"
import script from "./InvoiceDetectedInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetectedInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetectedInfo.vue?vue&type=style&index=0&id=3442f043&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442f043",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VDivider,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems})
